import {
  CateringCategoryChild,
  CateringCategoryQuery
} from 'components/pages/CateringPage/types/CateringCategoryQuery'
import Image from 'components/Image'
import Link from 'next/link'
import React from 'react'
import ButtonLink from 'components/ui/ButtonLink'

type Props = {
  category: NonNullable<CateringCategoryQuery['cateringCategory']>
}

export default function OtherCategories({ category }: Props) {
  let categories: (CateringCategoryChild & {
    marketCustomerPath: string
  })[] = []
  if (category.mainPage) {
    categories = category.childCategories
  } else if (category.parentCategory) {
    categories = [
      category.parentCategory!,
      ...category.parentCategory!.childCategories.filter(
        (c) => c.id !== category.id
      )
    ]
  } else {
    categories = category.childCategories
  }

  categories = categories.filter((c) => c.active)

  if (categories.length === 0) return null

  return (
    <div className="relative bg-white pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
            Similar catering events
          </h2>
        </div>
        <div
          className="mt-12 max-w-lg mx-auto grid gap-5 grid-cols-2 lg:grid-cols-4 lg:max-w-none"
          style={{ justifyItems: 'center' }}
        >
          {categories.map((child) => (
            <div
              key={child.name}
              className="flex flex-col rounded-lg shadow-lg overflow-hidden"
            >
              {child.image && (
                <div className="w-full">
                  <Image
                    alt={child.name}
                    className="w-full object-cover"
                    height={360}
                    layout="responsive"
                    src={child.image?.url}
                    width={360}
                  />
                </div>
              )}
              <div className="flex-1 bg-white p-6 pt-0 flex flex-col justify-between">
                <div className="flex-1">
                  <Link
                    className="hover:underline"
                    href={child.marketCustomerPath}
                    prefetch={false}
                  >
                    <div className="block mt-2">
                      <p className="text-xl font-semibold text-orange-600">
                        {child.name}
                      </p>
                      {child.subtitle && (
                        <p className="mt-3 text-base text-gray-500">
                          {child.subtitle}
                        </p>
                      )}
                    </div>
                  </Link>
                </div>
                <div className="mt-6">
                  <ButtonLink
                    color="primary"
                    href={child.marketCustomerPath}
                    variant="outline"
                  >
                    Explore
                  </ButtonLink>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
